import { useCallback } from 'react';
import { getCurrencyFormat } from '../helpers/getCurrencyFormat';
import { useSessionData } from '../firebase/hooks';
import { useLanguage } from './useLanguage';

export const useCurrencyFormatter = () => {
  const { language } = useLanguage();

  const { order } = useSessionData();

  return useCallback(
    (amount: number) => {
      return getCurrencyFormat(amount, order?.currency, language);
    },
    [language, order?.currency],
  );
};
